import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';

const Tarifarios = () => {
    const history = useHistory();
    const { userPermissions } = useMantenedores();
    const permisos = userPermissions?.modules?.tarifarios || {};

    const navigateToCompleto = () => {
        history.push('/mantenedores/tarifarios/completo');
    };

    const navigateToErrores = () => {
        history.push('/mantenedores/tarifarios/errores');
    };

    const navigateToEmpresas = () => {
        history.push('/mantenedores/tarifarios/empresas');
    };

    return (
        <SimpleMantenedorLayout
            mantenedorId="tarifarios"
            title="Mantenedor de Tarifarios"
            subtitle="Sistema de gestión de tarifarios y precios por entrega"
            iconColor="#007bff"
            showBackButton={false}
            breadcrumbs={[
                {
                    label: 'Tarifarios'
                }
            ]}
        >
            <Row className="mt-4">
                <Col xs={12}>
                    <div style={{ marginBottom: '24px' }}>
                        <h4 style={{ color: '#212529', marginBottom: '8px' }}>
                            Gestión de Tarifarios
                        </h4>
                        <p style={{ color: '#6c757d', marginBottom: '0' }}>
                            Selecciona el módulo de tarifarios que deseas gestionar
                        </p>
                    </div>
                </Col>
            </Row>

            <Row className="g-4">
                {/* Tarifario Empresas */}
                <Col xs={12} md={6} lg={4}>
                    <Card 
                        className="h-100 shadow-sm border-0"
                        style={{ 
                            cursor: permisos.canView ? 'pointer' : 'not-allowed',
                            opacity: permisos.canView ? 1 : 0.6,
                            transition: 'all 0.3s ease'
                        }}
                        onClick={permisos.canView ? navigateToEmpresas : undefined}
                    >
                        <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                            <div 
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    backgroundColor: '#e8f5e8',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '20px'
                                }}
                            >
                                <FaIcons.FaBuilding 
                                    style={{ 
                                        fontSize: '2rem', 
                                        color: '#28a745' 
                                    }} 
                                />
                            </div>
                            
                            <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                                Tarifario Empresas
                            </h5>
                            
                            <p style={{ 
                                color: '#6c757d', 
                                marginBottom: '20px',
                                fontSize: '0.95rem',
                                lineHeight: '1.5'
                            }}>
                                Gestiona precios específicos por empresa y comuna
                            </p>
                            
                            <div className="mt-auto">
                                <Button
                                    variant="outline-success"
                                    size="sm"
                                    disabled={!permisos.canView}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (permisos.canView) navigateToEmpresas();
                                    }}
                                >
                                    <FaIcons.FaArrowRight className="me-2" />
                                    Gestionar
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Tarifario Completo */}
                <Col xs={12} md={6} lg={4}>
                    <Card 
                        className="h-100 shadow-sm border-0"
                        style={{ 
                            cursor: permisos.canView ? 'pointer' : 'not-allowed',
                            opacity: permisos.canView ? 1 : 0.6,
                            transition: 'all 0.3s ease'
                        }}
                        onClick={permisos.canView ? navigateToCompleto : undefined}
                    >
                        <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                            <div 
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    backgroundColor: '#e3f2fd',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '20px'
                                }}
                            >
                                <FaIcons.FaTable 
                                    style={{ 
                                        fontSize: '2rem', 
                                        color: '#007bff' 
                                    }} 
                                />
                            </div>
                            
                            <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                                Tarifario Completo
                            </h5>
                            
                            <p style={{ 
                                color: '#6c757d', 
                                marginBottom: '20px',
                                fontSize: '0.95rem',
                                lineHeight: '1.5'
                            }}>
                                Gestiona tarifarios por destino con filtros avanzados
                            </p>
                            
                            <div className="mt-auto">
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    disabled={!permisos.canView}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (permisos.canView) navigateToCompleto();
                                    }}
                                >
                                    <FaIcons.FaArrowRight className="me-2" />
                                    Gestionar
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Errores de Tarifario */}
                <Col xs={12} md={6} lg={4}>
                    <Card 
                        className="h-100 shadow-sm border-0"
                        style={{ 
                            cursor: permisos.canView ? 'pointer' : 'not-allowed',
                            opacity: permisos.canView ? 1 : 0.6,
                            transition: 'all 0.3s ease'
                        }}
                        onClick={permisos.canView ? navigateToErrores : undefined}
                    >
                        <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                            <div 
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    backgroundColor: '#ffebee',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '20px'
                                }}
                            >
                                <FaIcons.FaExclamationTriangle 
                                    style={{ 
                                        fontSize: '2rem', 
                                        color: '#dc3545' 
                                    }} 
                                />
                            </div>
                            
                            <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                                Errores de Tarifario
                            </h5>
                            
                            <p style={{ 
                                color: '#6c757d', 
                                marginBottom: '20px',
                                fontSize: '0.95rem',
                                lineHeight: '1.5'
                            }}>
                                Gestiona y corrige errores en el sistema de tarifarios de forma masiva
                            </p>
                            
                            <div className="mt-auto">
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    disabled={!permisos.canView}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (permisos.canView) navigateToErrores();
                                    }}
                                >
                                    <FaIcons.FaArrowRight className="me-2" />
                                    Gestionar
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </SimpleMantenedorLayout>
    );
};

export default Tarifarios;
